export default __webpack_public_path__ + "1de7e40c9762880b56f0412ec8e538e1.png";